import { timeFormat } from "d3";
import axios from "axios";
import { authHeader } from "@/_helpers";
import { apiService } from "@/_services";

// Generate file name with specific format
function generateFilename(nameCompany, listFile) {
  const formatTime = timeFormat("%Y-%m-%d");
  return `${nameCompany.replace(/ /g, "_")}-${listFile}${formatTime(new Date())}.xlsm`;
}

// Download and save a file from a link
async function downloadAndSaveFile(link, filename) {
  try {
    const { data } = await axios.get(link, { responseType: "blob" });
    const contentType = "application/vnd.ms-excel.sheet.macroEnabled.12";
    const blob = new Blob([data], { type: contentType });

    const downloadUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = `${filename}.xlsm`;
    document.body.appendChild(a);
    a.click();
  } catch (error) {
    console.error(error);
  }
}

export function createExcel(
  _this,
  listFile,
  nameCompany,
  data,
  originSelection,
  orderedList,
  numberFile
) {
  const filename = generateFilename(nameCompany, listFile);

  axios
    .post(
      `${process.env.VUE_APP_GATEWAY_URL}user/create-optimizer-file`,
      {
        format: "json",
        data,
        origin: originSelection,
        filename,
        ordered_list: [{ ordered_list: orderedList }],
        name_company: nameCompany,
        number_file: numberFile,
      },
      { headers: authHeader() }
    )
    .then((response) =>
      downloadAndSaveFile(response.data.link, filename)
    )
    .catch((error) => console.error(error));
}

export function createExcelAPI(
  _this,
  endpoint,
  listFile,
  nameCompany,
  data,
  originSelection
) {
  Object.assign(_this.loading, {
    showModalLoading: true,
    messageModal: "Processing download...",
    options: false,
    optionsModal: false,
  });
  const filename = generateFilename(nameCompany, listFile);

  let params = {
    method: "POST",
    endpoint: endpoint,
    content_type: "application/json",
    query_params: {
      format: "json",
      filename,
      origin: originSelection,
      name_company: nameCompany,
      table: data,
    },
  };

  apiService
    .getAll(params)
    .then((response) => {
      downloadAndSaveFile(response.link, filename);
      Object.assign(_this.loading, {
        showModalLoading: false,
        messageModal: "",
      });
    })
    .catch((e) => {
      Object.assign(_this.loading, {
        showModalLoading: false,
        messageModal: "Error downloading file",
        optionsModal: true,
      });
      console.error(e);
    });
}

export function createExcelValuation(
  _this,
  listFile,
  nameCompany,
  data,
  originSelection
) {
  return createExcelAPI(
    _this,
    "create_valuation_file",
    listFile,
    nameCompany,
    data,
    originSelection
  );
}

export function createExcelCommManagement(
  _this,
  listFile,
  nameCompany,
  data,
  originSelection
) {
  return createExcelAPI(
    _this,
    "create_commodity_management_file",
    listFile,
    nameCompany,
    data,
    originSelection
  );
}
